// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2KYal","productName":"Table_productName__2VX7l"};